import type { Component } from 'vue';

import ModalFill from '@/components/shared/composite/ModalFill.vue';
import ModalSmall from '@/components/shared/composite/ModalSmall.vue';
import { TypeTheme } from '@/types/common';

export const DOMAIN = {
  CHAT: 'CHAT',
  SELF_SERVICE: 'SELF_SERVICE',
  ADMIN: 'ADMIN',
  DISTRIBUTOR: 'DISTRIBUTOR',
  HEAD_OFFICE: 'HEAD_OFFICE',
} as const;

export const MODAL_COMPONENT_MAP: Readonly<Record<string, Component>> = {
  small: ModalSmall,
  fill: ModalFill,
} as const;

export const FIELD_LABEL_MAP = {
  chatName: 'label_interpretation_name',
  partnerGroupName: 'label_description',
  startTime: 'label_interpretation_start_time',
  endTime: 'label_interpretation_end_time',
  loginId: 'label_id',
  name: 'label_name',
  callType: 'label_type',
  title: 'label_interpretation_name',
  usageFee: 'label_fee',
  attendees: 'label_attendees',
  receiver: 'label_attendees',
  usageDurationMinutes: 'label_usage_time',
  usagePeriod: 'label_usage_period',
};

export const FIELD_FORMAT_MAP = {
  receiver: (t: string) => t.replaceAll(',', ',\n'),
  groupName: (t: string) => t.replaceAll(',', ',\n'),
  attendees: (t: string) => t.replaceAll(',', ',\n'),
  totalAttendees: (t: string) => t || 0,
};

export const PARTNER_TYPE_MAP = {
  HEAD_OFFICE: 'internal',
  CUSTOMER: 'admin',
  SELF_SERVICE: 'ss',
};

export const LANGUAGES_WITHOUT_SPACES = [
  'zh', // 중국어
  'ja', // 일본어
  'th', // 태국어
  'lo', // 라오어
  'my', // 미얀마어
  'km', // 크메르어
];

export const BREAKPOINTS = {
  TABLET: 768,
  DESKTOP: 1200,
};

export const SOCIAL_PROVIDER_MAPPER = {
  meta: 'THIRD_PARTY_META',
  google: 'THIRD_PARTY_GOOGLE',
  apple: 'THIRD_PARTY_APPLE',
} as const;

export const THEME_LIGHT: TypeTheme = 'light';
export const THEME_DARK: TypeTheme = 'dark';

export const FILE_EXTENSIONS = {
  TXT: 'txt',
  WORD: 'docx',
  PDF: 'pdf',
} as const;

export const MIC_SIGNAL_TIMEOUT_MS = 5000;

export const CHAT_TYPE_DETAIL_FILTERS = [
  { value: 'ALL', label: 'label_all' },
  { value: 'MEETING', label: 'label_meeting' },
  { value: 'CONFERENCE', label: 'label_conference' },
  { value: 'AUDIENCE', label: 'label_audience' },
  { value: 'GENERAL', label: 'label_general' },
  { value: 'SINGLE', label: 'label_single' },
] as const;

export const LOCALE_NUMBER_FORMAT = 'en-US';

export const PROD_ORIGIN = 'https://sconchat.sconai.com';
export const DEV_ORIGIN = 'https://dev-web-sconchat.sconai.com';

export const ASSETS_IMAGE_BASE = '/src/assets/images/';
